import { render, staticRenderFns } from "./UpgradeProfessionModal.vue?vue&type=template&id=5ca22260&scoped=true&"
import script from "./UpgradeProfessionModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeProfessionModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeProfessionModal.vue?vue&type=style&index=0&id=5ca22260&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca22260",
  null
  
)

export default component.exports